import { Chip, Grid, Typography } from "@mui/material";
import React from "react";
import MainCard from "../../../../components/Maincard";
import { DataGrid } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "../../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import { formatTime, fTimestamp } from "../../../../utils/formatTime";
import parse from "html-react-parser";
export default function EventCounsellingDetailsData({ detailsData }) {

  const handleViewMore = (row) => {
    console.log("rowdata" , row)
   
    window.open(`/enquiry-summary/${row?.enq_personal_details_id?.id}`, '_blank');

  
  };

  const columns = [
    {
      field: "name",
      headerName: "Enquiry Name",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.enq_personal_details_id?.first_name || ""} ${
          params.row?.enq_personal_details_id?.last_name || ""
        }`,
      renderCell: (params) => (
        <div style={{color:"#479eea" , cursor:"pointer"}}  onClick={()=>handleViewMore(params?.row)}>
          {params.row?.enq_personal_details_id?.first_name}{" "}
          {params.row?.enq_personal_details_id?.last_name}{" "}
        </div>
      ),
    },
    {
      field: "mobile",
      headerName: "Mobile",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <div>{params.row?.enq_personal_details_id?.mobile}</div>
      ),
    },

    {
      field: "event_name",
      headerName: "Event Name",
      flex: 1,
      minWidth: 350,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => <div>{params.row?.event_id?.campaign_name}</div>,
    },

    {
      field: "counselling_by",
      headerName: "Counselling By",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <div>
          {params.row?.counselling_by?.first_name}{" "}
          {params.row?.counselling_by?.last_name}
        </div>
      ),
    },

    {
      field: "counselling_date",
      headerName: "Counselling Date",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
    },

    {
      field: "start_time",
      headerName: "Start Time",
      flex: 1,
      minWidth: 100,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => <div>{formatTime(params.row?.start_time)}</div>,
    },

    {
      field: "end_time",
      headerName: "End Time",
      flex: 1,
      minWidth: 100,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <div>
          {params?.row?.end_time ? formatTime(params?.row?.end_time) : ""}
        </div>
      ),
    },

   

    {
      field: "profile_analysis",
      headerName: "Profile Analysis",
      flex: 1,
      minWidth: 100,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "ready_to_apply",
      headerName: "Ready To Apply",
      flex: 1,
      minWidth: 100,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <div>
          {params?.row?.ready_to_apply === 1
            ? "Yes"
            : params?.row?.ready_to_apply === 0
            ? "No"
            : ""}
        </div>
      ),
    },
     {
      field: "is_counselling_ended",
      headerName: "Is Counselling Ended",
      flex: 1,
      minWidth: 100,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <div>
          {params?.row?.is_counselling_ended === 1
            ? <Chip label="Completed" variant="contained" size="small" color="secondary"/>
            : params?.row?.is_counselling_ended === 0
            ? <Chip label="Incomplete" variant="contained" size="small" color="error"/> 
            : ""}
        </div>
      ),
      
    },
    {
      field: "notes",
      headerName: "Notes",
      flex: 1,
      minWidth: 550,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <div>{params?.row?.notes ? parse(params?.row?.notes) : ""}</div>
      ),
    },
  ];

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <MainCard>
            <DataGrid
              rows={detailsData}
              columns={columns}
              autoHeight
              slots={{
                noRowsOverlay: CustomNoRowsOverlay,
              }}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 25,
                  },
                },
              }}
              pageSizeOptions={[25, 50, 100]}
            />
          </MainCard>
        </Grid>
      </Grid>
    </>
  );
}
